// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1tgUE","left":"StickyBox_left__3RR4z","right":"StickyBox_right__7Jz3C"};